/**
 * Nome leggibile di un documento archiviato.
 *
 * [sc-48497 / task 48531] Il nome dell'oggetto lo fa il server e porta davanti
 * l'azienda — `company-6-quote-12-Preventivo_N_12.pdf` — perché in un bucket
 * solo due clienti che caricano lo stesso file si sovrascriverebbero a
 * vicenda. Quel prefisso serve allo storage, non a chi guarda: qui viene tolto.
 *
 * I documenti caricati prima di quella modifica hanno il nome nudo e
 * attraversano questa funzione senza cambiare.
 */

/** Prefisso messo dal server: azienda, tipo di documento e id del padre. */
const SERVER_PREFIX = /^company-\d+-(?:quote|ddt)-\d+-/i;

/** Toglie il prefisso dello storage, lasciando il nome come lo legge una persona. */
export function stripStoragePrefix(name) {
  return (name ?? "").toString().replace(SERVER_PREFIX, "");
}

export function formatDocName(name) {
  return (
    stripStoragePrefix(name)
      // toglie un eventuale ".dev" subito prima di ".pdf"
      .replace(/\.dev(?=\.pdf$)/i, "")
      // e infine "_N_<numero>.pdf" in fondo
      .replace(/_N_\d+\.pdf$/i, "")
  );
}
